// extracted by mini-css-extract-plugin
export var backgroundImage = "SectionImageRightSupport-module--backgroundImage--0b095";
export var content = "SectionImageRightSupport-module--content--9bf4f";
export var cta = "SectionImageRightSupport-module--cta--ffc93";
export var main = "SectionImageRightSupport-module--main--81f95";
export var subTitle = "SectionImageRightSupport-module--subTitle--41923";
export var title = "SectionImageRightSupport-module--title--a8577";
export var wrapper = "SectionImageRightSupport-module--wrapper--adec3";